// @flow
import axios from 'axios';
import { isLocalhost, getDeployment } from "./deployment";

let host = `https://${getDeployment()}.lln.training/api`;
if (isLocalhost()) {
    host = process.env.LOCALHOST || 'http://localhost:4090';
}
axios.defaults.baseURL = host;

export default axios;


// WEBPACK FOOTER //
// ./src/utils/axios.js